"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var WL = {
		Client: {

				API_VERSION: "2.14",

				init: function init(wlInitOptions) {
						wlCommonInit();
				},

				makeUrl: function makeUrl(url) {
						if (inBrowser) {
								return url;
						} else {
								return BaseUrlManager.baseUrl + url;
						}
				},

				getApiVersions: function getApiVersions(xhr) {
						var actual = xhr.getResponseHeader("tm-api-version-actual");
						if (!actual) {
								actual = "2.7";
						}
						return { expected: WL.Client.API_VERSION, actual: actual };
				},

				invokeProcedureDeferred: function invokeProcedureDeferred(invocationData) {
						var url = this.makeUrl("adapter");

						return $.ajax({
								url: url,
								type: "POST",
								headers: { "tm-api-version-requested": WL.Client.API_VERSION },
								dataType: "json",
								data: invocationData });
				},

				invokeProcedure: function invokeProcedure(invocationData, callbacks) {
						var url = this.makeUrl("adapter");

						$.ajax({
								url: url,
								type: "POST",
								headers: { "tm-api-version-requested": WL.Client.API_VERSION },
								dataType: "json",
								data: invocationData,
								success: function success(data, status, xhr) {
										if (callbacks.onSuccess) callbacks.onSuccess(data, status, xhr);
								},
								error: function error(jqXHR) {
										if (callbacks.onFailure) callbacks.onFailure(jqXHR);
								}
						});
				},

				post: function () {
						var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(invocationData) {
								var url;
								return regeneratorRuntime.wrap(function _callee$(_context) {
										while (1) {
												switch (_context.prev = _context.next) {
														case 0:
																url = this.makeUrl("adapter");
																return _context.abrupt("return", new Promise(function (resolve, reject) {
																		$.ajax({
																				url: url,
																				type: "POST",
																				headers: { "tm-api-version-requested": WL.Client.API_VERSION },
																				dataType: "json",
																				data: invocationData,
																				success: function success(data, status, xhr) {
																						resolve(data, status, xhr);
																				},
																				error: function error(jqXHR) {
																						reject(jqXHR);
																				}
																		});
																}));

														case 2:
														case "end":
																return _context.stop();
												}
										}
								}, _callee, this);
						}));

						function post(_x) {
								return _ref.apply(this, arguments);
						}

						return post;
				}()

		},

		JSONStore: {
				collections: null,

				init: function init(collectionsInit) {
						this.collections = {};
						for (var collName in collectionsInit) {
								this.collections[collName] = new JSONStoreCollection(collName, collectionsInit[collName]);
						}
						return WL.JSONStore._promise(this);
				},

				get: function get(collName) {
						return this.collections[collName];
				},

				_promise: function _promise(result, failed) {
						var deferred = $.Deferred();
						if (failed) deferred.reject(result);else deferred.resolve(result);
						return deferred.promise();
				}
		}
};

var JSONStoreCollection = new JS.Class({
		name: null,
		info: null,

		initialize: function initialize(name, opts) {
				this.options = opts;
				this.name = name;
				this.key = 'mymobile_collections_' + this.name;
				this.info = JSONStorage.read(this.key, this.options.sessionOnly);
				if (this.info == null) {
						this.info = { nextId: 1, data: [] };
						this._save();
				}
		},

		add: function add(obj) {
				var saveObj = { _id: this.info.nextId, json: obj };
				this.info.nextId += 1;
				this.info.data.push(saveObj);
				this._save();
				return WL.JSONStore._promise(saveObj);
		},

		remove: function remove(obj) {
				var searchDef = this._makeSearchDefinition(obj);
				if (searchDef.type == 'id') return this.removeById(searchDef._id);else if (searchDef.type == 'all') return this._removeAll();else if (searchDef.type == 'query') {
						var newList = this._query(searchDef.query, false);
						var numDel = this.info.data.length - newList.length;
						this.info.data = newList;
						this._save();
						return WL.JSONStore._promise(numDel);
				} else return WL.JSONStore._promise({ msg: 'not implemented' }, false);
		},

		replace: function replace(obj) {
				for (var i = 0; i < this.info.data.length; i++) {
						var row = this.info.data[i];
						if (obj._id == row._id) {
								this.info.data[i] = obj;
								this._save();
								return WL.JSONStore._promise(1);
						}
				}
				return WL.JSONStore._promise({ msg: 'not found' }, false);
		},

		removeById: function removeById(objId) {
				for (var i = 0; i < this.info.data.length; i++) {
						var row = this.info.data[i];
						if (objId == row._id) {
								this.info.data.splice(i, 1);
								this._save();
								return WL.JSONStore._promise(1);
						}
				}
				return WL.JSONStore._promise({ msg: 'not found' }, false);
		},

		findAll: function findAll() {
				var result = this.info.data.concat([]);
				return WL.JSONStore._promise(result);
		},

		find: function find(qry) {
				var result;
				var sDef = this._makeSearchDefinition(qry);
				if (sDef.type == 'all') result = this.info.data.concat([]);else if (sDef.type == 'query') result = this._query(sDef.query, true);

				return WL.JSONStore._promise(result);
		},

		_save: function _save() {
				JSONStorage.write(this.key, this.info, this.options.sessionOnly);
		},

		_query: function _query(qry, keep) {
				// keep - false to invert the query
				var result = [];
				var data = this.info.data;
				for (var i = 0; i < data.length; i++) {
						var item = data[i];
						var include = true;
						for (var key in qry) {
								if (item.json[key] != qry[key]) {
										include = false;
								}
						}
						if (keep == include) result.push(item);
				}
				return result;
		},

		_removeAll: function _removeAll() {
				var numDel = this.info.data.length;
				this.info.data = [];
				this._save();
				return WL.JSONStore._promise(numDel);
		},

		_makeSearchDefinition: function _makeSearchDefinition(obj) {
				var searchDef = { type: 'invalid' };
				if ($.isNumeric(obj)) {
						searchDef = { type: 'id', _id: parseInt(obj) };
				} else if ($.isPlainObject(obj)) {
						if (obj._id !== undefined) searchDef = { type: 'id', _id: parseInt(obj._id) };else if ($.isEmptyObject(obj)) searchDef = { type: 'all' };else searchDef = { type: 'query', query: obj };
				}
				return searchDef;
		}
});

var JSONStorage = {
		read: function read(key, sessionOnly) {
				return this.jsonData(this.storage(sessionOnly).getItem(key));
		},

		write: function write(key, data, sessionOnly) {
				this.storage(sessionOnly).setItem(key, JSON.stringify(data));
		},

		remove: function remove(key, sessionOnly) {
				this.storage(sessionOnly).removeItem(key);
		},

		jsonData: function jsonData(data) {
				if (data) return JSON.parse(data);else return null;
		},

		clear: function clear() {
				sessionStorage.clear();
				localStorage.clear();
		},

		storage: function storage(sessionOnly) {
				if (sessionOnly) {
						return sessionStorage;
				} else {
						return sessionStorage;
				}
		}
};